import { IPreloadedState } from 'shared/types/redux';

export const selectDistrictsSwitcher = (state: IPreloadedState) => state.geo.districtsSwitcher;
